import { render, staticRenderFns } from "./hotsale-product.vue?vue&type=template&id=5cd407be&scoped=true&"
import script from "./hotsale-product.vue?vue&type=script&lang=js&"
export * from "./hotsale-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd407be",
  null
  
)

export default component.exports